import * as React from "react";
const SvgSupportLeg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 100, viewBox: "0 0 25.0 100.0", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 0.0 0.0 L 0.0 100.0 L 25.0 100.0 L 25.0 0.0", fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgSupportLeg;
